export default "__VITE_ASSET__ab07d1b1__"